"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipContent = void 0;
var react_1 = __importDefault(require("react"));
var currency_1 = require("@nerdwallet/currency");
var filter_component_module_css_1 = __importDefault(require("./filter-component.module.css"));
var nerdwallet_plus_logo_1 = require("../nerdwallet-plus-logo");
var TooltipContent = function (_a) {
    var onClickHyperlink = _a.onClickHyperlink, href = _a.href;
    return (react_1.default.createElement(currency_1.Box, { id: "tooltip-content", className: filter_component_module_css_1.default.tooltipBox },
        react_1.default.createElement(currency_1.Type, { className: filter_component_module_css_1.default.accounts },
            "Accounts with the ",
            react_1.default.createElement(nerdwallet_plus_logo_1.NerdWalletPlusLogo, { height: 16, small: true }),
            " label are eligible for $100 in rewards through NerdWallet+."),
        react_1.default.createElement(currency_1.Link, { href: href, onClick: onClickHyperlink, className: filter_component_module_css_1.default.link }, "ABOUT NERDWALLET+")));
};
exports.TooltipContent = TooltipContent;
